import { Input, Stack } from '@chakra-ui/react'
import type { HTMLProps } from 'react'
import { forwardRef } from 'react'
import { BiSearch } from 'react-icons/bi'

import { Field } from '@app/components/ui/field'
import { InputGroup } from '@app/components/ui/input-group'

type Props = Omit<HTMLProps<HTMLFormElement>, 'ref'>

const MapDrawerQueryForm = forwardRef<HTMLFormElement, Props>(({ children, ...formProps }, ref) => (
  <form ref={ref} {...formProps}>
    <Stack py={4}>
      {children}
      <Field>
        <InputGroup startElement={<BiSearch />} w="full">
          <Input name="query" placeholder="Find..." />
        </InputGroup>
      </Field>
    </Stack>
  </form>
))

export default MapDrawerQueryForm
